import styled from 'styled-components';

export const BuilderPage = styled.div`
  width: 100%;
  max-width: 1152px;
  padding: 32px 24px 48px;
  color: var(--white);

  @media (min-width: 1024px) {
    padding: 40px 40px 56px;
  }

  .back {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 24px;
    border: 0;
    background: transparent;
    color: #a0a0a0;
    font-size: 14px;
    cursor: pointer;

    &:hover {
      color: var(--white);
    }
  }

  .page-title {
    margin-bottom: 32px;

    h1 {
      margin: 0 0 8px;
      font-size: 30px;
      font-weight: 700;
      color: var(--white);
    }

    p {
      margin: 0;
      font-size: 15px;
      color: #a0a0a0;
    }
  }

  .layout {
    display: grid;
    gap: 24px;

    @media (min-width: 1024px) {
      grid-template-columns: 1fr 2fr;
    }
  }

  .stack {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .card {
    padding: 20px;
    border-radius: 12px;
    background: #161616;
    border: 1px solid #262626;
  }

  .card-title {
    margin: 0 0 16px;
    font-size: 14px;
    font-weight: 600;
    color: var(--white);
  }

  .field {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    label {
      display: block;
      margin-bottom: 6px;
      font-size: 14px;
      color: var(--white);

      .req {
        color: #ef4444;
        margin-right: 4px;
      }
    }

    input,
    textarea,
    .select-trigger {
      width: 100%;
      padding: 8px 12px;
      border-radius: 8px;
      border: 1px solid #262626;
      background: #0e0e0e;
      color: var(--white);
      font-size: 14px;
      outline: none;

      &::placeholder {
        color: #606060;
      }

      &:focus {
        border-color: rgba(3, 160, 141, 0.4);
      }
    }

    textarea {
      resize: vertical;
      min-height: 120px;
      line-height: 1.5;
    }
  }

  .select {
    position: relative;

    .select-trigger {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      cursor: pointer;
      text-align: left;

      .placeholder {
        color: #606060;
      }
    }

    .backdrop {
      position: fixed;
      inset: 0;
      z-index: 10;
    }

    .menu {
      position: absolute;
      z-index: 20;
      top: calc(100% + 4px);
      left: 0;
      right: 0;
      max-height: 240px;
      overflow-y: auto;
      border-radius: 8px;
      border: 1px solid #262626;
      background: #1a1a1a;
    }

    .option {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 12px;
      border: 0;
      background: transparent;
      color: var(--white);
      font-size: 14px;
      text-align: left;
      cursor: pointer;

      &:hover {
        background: rgba(255, 255, 255, 0.05);
      }
    }

    .empty {
      padding: 8px 12px;
      font-size: 12px;
      color: #707070;
    }
  }

  .type-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;

    button {
      padding: 8px;
      border-radius: 8px;
      border: 1px solid #262626;
      background: transparent;
      color: #808080;
      font-size: 13px;
      cursor: pointer;

      &.active {
        border-color: var(--primary);
        background: rgba(3, 160, 141, 0.08);
        color: var(--white);
      }
    }
  }

  .icon-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;

    .preview {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      overflow: hidden;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .swatches {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;

      button {
        width: 24px;
        height: 24px;
        border-radius: 999px;
        border: 2px solid transparent;
        cursor: pointer;
        padding: 0;

        &.active {
          border-color: var(--white);
        }
      }
    }

    .remove {
      border: 0;
      background: transparent;
      color: #a0a0a0;
      font-size: 12px;
      cursor: pointer;

      &:hover {
        color: var(--white);
      }
    }
  }

  .upload-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    border: 0;
    background: transparent;
    color: #606060;
    font-size: 12px;
    cursor: pointer;

    &:hover {
      color: #a0a0a0;
    }
  }

  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
    margin-bottom: 12px;

    span {
      padding: 4px 10px;
      border-radius: 999px;
      font-size: 12px;
    }

    &.tools span {
      background: rgba(16, 185, 129, 0.1);
      color: #10b981;
      border: 1px solid rgba(16, 185, 129, 0.2);
    }

    &.skills span {
      background: rgba(245, 158, 11, 0.1);
      color: #f59e0b;
      border: 1px solid rgba(245, 158, 11, 0.2);
    }
  }

  .templates {
    display: grid;
    gap: 8px;
    margin-bottom: 16px;

    @media (min-width: 640px) {
      grid-template-columns: 1fr 1fr;
    }

    button {
      text-align: left;
      padding: 12px;
      border-radius: 8px;
      border: 1px solid #262626;
      background: transparent;
      cursor: pointer;

      &:hover {
        border-color: #333;
      }

      &.active {
        border-color: var(--primary);
        background: rgba(3, 160, 141, 0.05);
      }

      .label {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 4px;
        font-size: 14px;
        font-weight: 500;
        color: var(--white);
      }

      .text {
        font-size: 12px;
        color: #808080;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }

  .toggles {
    display: grid;
    gap: 16px;

    @media (min-width: 768px) {
      grid-template-columns: 1fr 1fr;
    }
  }

  .toggle-card {
    padding: 20px;
    border-radius: 8px;
    background: #0e0e0e;
    border: 1px solid #262626;

    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      label {
        font-size: 14px;
        color: var(--white);
      }
    }

    .switch {
      position: relative;
      width: 40px;
      height: 24px;
      border: 0;
      border-radius: 999px;
      background: #333;
      cursor: pointer;

      &.on {
        background: var(--primary);
      }

      span {
        position: absolute;
        top: 2px;
        left: 2px;
        width: 20px;
        height: 20px;
        border-radius: 999px;
        background: #fff;
        transition: transform 0.15s ease;
      }

      &.on span {
        transform: translateX(16px);
      }
    }

    .status {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 12px;
      border-radius: 8px;
      background: #161616;
      border: 1px solid #262626;

      .icon {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.05);
        color: #707070;

        &.on {
          background: rgba(3, 160, 141, 0.12);
          color: var(--primary);
        }
      }

      span {
        font-size: 14px;
        color: var(--white);
      }
    }

    .desc {
      margin: 12px 0 0;
      font-size: 12px;
      line-height: 18px;
      color: #808080;
    }
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 8px;

    .cancel {
      padding: 10px 20px;
      border: 0;
      background: transparent;
      color: #a0a0a0;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        color: var(--white);
      }
    }

    .save {
      padding: 10px 24px;
      border: 0;
      border-radius: 999px;
      background: var(--primary);
      color: var(--white);
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      &:hover:not(:disabled) {
        opacity: 0.9;
      }
    }
  }

  .grid-2 {
    display: grid;
    gap: 12px;

    @media (min-width: 640px) {
      grid-template-columns: 1fr 1fr;
    }
  }

  .hint {
    margin: 6px 0 0;
    font-size: 12px;
    color: #707070;
  }

  .coming-soon {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    min-height: 180px;

    .overlay {
      position: absolute;
      inset: 0;
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 4px;
      padding: 16px;
      background: rgba(14, 14, 14, 0.72);
      backdrop-filter: blur(2px);
      text-align: center;
      pointer-events: auto;

      strong {
        font-size: 14px;
        font-weight: 600;
        color: var(--white);
      }

      span {
        max-width: 280px;
        font-size: 12px;
        line-height: 18px;
        color: #a0a0a0;
      }
    }

    .dimmed {
      opacity: 0.35;
      pointer-events: none;
      user-select: none;
    }
  }
`;
